import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import InformationIcon from 'zignal-landscape/lib/Icon/InformationIcon';

const EmptyTable = ({styles, header, body}) => {
  return (
    <div className={styles.EmptyTable}>
      <span className={styles.EmptyTableIcon}><InformationIcon width={45} height={45} /></span>
      <div className={styles.EmptyTableText1}>{header}</div>
      <div className={styles.EmptyTableText2}>{body}</div>
    </div>
  );
};

EmptyTable.propTypes = {
  styles: PropTypes.object,
  header: PropTypes.node,
  body: PropTypes.node
};

export default themeable(EmptyTable);
